import { cn } from '@/shared/lib/cn';
import type { HTMLAttributes, ReactNode } from 'react';

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  /** Diameter in px. Defaults to 18. */
  size?: number;
  label?: string;
}

/**
 * Minimal, dependency-free loading spinner. Inherits `currentColor`, so it
 * tints to whatever text color its container sets. Used inside buttons and as
 * the atom of the page loader.
 */
export function Spinner({
  size = 18,
  label,
  className,
  ...rest
}: SpinnerProps): ReactNode {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn('inline-flex', className)}
      {...rest}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
        className="animate-spin"
      >
        <circle
          cx="12"
          cy="12"
          r="9"
          stroke="currentColor"
          strokeWidth="2.5"
          className="opacity-20"
        />
        <path
          d="M21 12a9 9 0 0 0-9-9"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
      {label ? <span className="sr-only">{label}</span> : null}
    </span>
  );
}
